import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants"
import { ListFilter } from "../filterTypes/listFilter"
import { NumberFilter } from "../filterTypes/numberFilter"
import { StringFilter } from "../filterTypes/stringFilter"

export class ReleaseIdFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Release ID",
      FILTER_TYPE.ALG_RELEASE.ID,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return parseInt(alg_release.id, 10)
  }
}

export class ReleaseModelCountFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Model Count",
      FILTER_TYPE.ALG_RELEASE.MODEL_COUNT,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return alg_release.components.length
  }
}

export class ReleaseSensitivity extends ListFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Sensitivity",
      FILTER_TYPE.ALG_RELEASE.SENSITIVITY,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return alg_release.components.map((a) => a.sensitivity)
  }
}

export class ReleaseNameFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Name",
      FILTER_TYPE.ALG_RELEASE.NAME,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return alg_release.name
  }
}

export class ReleaseFrameworkFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Description",
      FILTER_TYPE.ALG_RELEASE.FRAMEWORK,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return alg_release.description
  }
}

export class ReleaseModelIDsFilter extends ListFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Model IDs",
      FILTER_TYPE.ALG_RELEASE.MODEL_IDS,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return alg_release.components.map((a) => a.algMetadataId.toString())
  }
}

export class ReleaseNormalizationFilter extends ListFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Image Normalization Methods",
      FILTER_TYPE.ALG_RELEASE.NORMALIZATION,
      [DATA_SCOPES.ALG_RELEASE],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    alg_release,
  ) {
    return alg_release.components.map((a) => a.imageNormalizationMethod)
  }
}
